// Syncs filter state with URL query params so filtered views are shareable.
// Example: ?term=2511&q=cs&subj=CS%20-%20Computer&inst=Smith%2C%20John&ztc=1
//
// Array values are joined with "|" because filter values may contain commas
// (e.g. instructor names like "Smith, John").

const FILTER_PARAMS = [
  { name: 'selectedTerm', key: 'term', type: 'string' },
  { name: 'searchBoxText', key: 'q', type: 'string' },
  { name: 'selectedSubjectCode', key: 'subj', type: 'array' },
  { name: 'courseNumberSearch', key: 'cnum', type: 'string' },
  { name: 'selectedInstructor', key: 'inst', type: 'array' },
  { name: 'selectedPtrm', key: 'ptrm', type: 'array' },
  { name: 'selectedLocation', key: 'loc', type: 'array' },
  { name: 'selectedScheduleCode', key: 'sched', type: 'array' },
  { name: 'selectedDaysOfWeek', key: 'days', type: 'array' },
  { name: 'selectedStartTime', key: 'st', type: 'string' },
  { name: 'selectedEndTime', key: 'et', type: 'string' },
  { name: 'selectedAttribute', key: 'attr', type: 'array' },
  { name: 'filterZTCOnly', key: 'ztc', type: 'bool' },
  { name: 'filterUnrestrictedOnly', key: 'unres', type: 'bool' },
  { name: 'filterOpenClasses', key: 'open', type: 'bool' },
  { name: 'filterWaitlistClasses', key: 'wait', type: 'bool' },
  { name: 'filterCredit', key: 'cred', type: 'bool' },
  { name: 'filterNonCredit', key: 'noncred', type: 'bool' },
];

const defaultValueFor = (type) => (type === 'array' ? [] : type === 'bool' ? false : type === 'string' ? '' : null);

/**
 * Parse the current (or given) URL search string into a filters object.
 * Keys match the App.js state variable names.
 */
export function readFiltersFromUrl(search = window.location.search) {
  const params = new URLSearchParams(search);
  const filters = {};
  for (const { name, key, type } of FILTER_PARAMS) {
    const raw = params.get(key);
    if (raw === null) {
      filters[name] = defaultValueFor(type);
    } else if (type === 'array') {
      filters[name] = raw.split('|').filter(Boolean);
    } else if (type === 'bool') {
      filters[name] = raw === '1';
    } else {
      filters[name] = raw;
    }
  }
  return filters;
}

/**
 * Write the given filters object into the URL (replaceState, so the
 * back button is not polluted with one entry per filter change).
 */
export function writeFiltersToUrl(filters) {
  const params = new URLSearchParams();
  for (const { name, key, type } of FILTER_PARAMS) {
    const value = filters[name];
    if (type === 'array') {
      if (Array.isArray(value) && value.length > 0) params.set(key, value.join('|'));
    } else if (type === 'bool') {
      if (value) params.set(key, '1');
    } else if (type === 'string') {
      if (value) params.set(key, value);
    } else {
      if (value !== null && value !== undefined) params.set(key, value);
    }
  }
  const qs = params.toString();
  const url = window.location.pathname + (qs ? `?${qs}` : '');
  window.history.replaceState(window.history.state, '', url);
}
